<div class="column-container align-center">
  <mat-spinner [diameter]="diameter()"/>
</div>
